<template>
  <div class="practice-card">
    <router-link :to="{name: 'practices.show', params: {id: practice.id}}" class="practice-card-content">
      <div class="practice-card-emoji" :class="{'bg-green-100': applied, 'bg-amber-100': bookmarked, 'bg-gray-100': defaulting}">
        <Twemoji :code="practice.emoji" class="w-16 h-16" />
      </div>
      <h3 class="practice-card-title">
        {{ practice.title }}
      </h3>
      <dl class="practice-card-keywords">
        <dt class="sr-only">
          Titel
        </dt>
        <dd class="mt-3">
          <SimilarityTooltip>
            <Similarity :value="practice.similarity" />
          </SimilarityTooltip>
        </dd>
      </dl>
    </router-link>
    <div>
      <PracticeCardMenu :practice="practice" />
    </div>
  </div>
</template>

<script setup>
import{ computed } from 'vue';
const props = defineProps({practice: Object});
const applied = computed(() => props.practice.applied);
const bookmarked = computed(() => props.practice.bookmarked);
const defaulting = computed(() => ! (applied.value || bookmarked.value));
</script>

<style scoped>
.practice-card
{
  @apply flex flex-col;
  @apply divide-y divide-gray-200;
  @apply rounded-lg bg-white shadow;
  @apply text-center;
}

.practice-card-content
{
  @apply flex flex-1 flex-col p-8;
}

.practice-card-emoji
{
  @apply flex flex-shrink-0 justify-center items-center;
  @apply mx-auto h-32 w-32;
  @apply rounded-full;
  @apply text-7xl;
}

.practice-card-title
{
  @apply text-sm font-medium text-gray-900;
  @apply mt-6;
}

.practice-card-keywords
{
  @apply flex flex-grow flex-col justify-between;
  @apply mt-1;
}

.practice-card-keyword
{
  @apply relative inline-flex items-center;
  @apply rounded-full border border-gray-300;
  @apply text-sm font-medium text-gray-900;
  @apply px-3 py-0.5;
}

.practice-link
{
  @apply relative inline-flex flex-1 items-center justify-center;
  @apply rounded-bl-lg border border-transparent;
  @apply text-sm font-medium text-gray-700 hover:text-gray-500;
  @apply -mr-px w-0 py-4;
}
</style>

